import { Ref } from 'react';
import styled from 'styled-components';

interface Props {
  id?: string;
  ref?: Ref<any>;
  handleChange: (event: any) => void;
  selected: string;
  owner?: boolean;
  items: any[];
}

const RadioButton = (props: Props) => {
  const { handleChange = () => {}, selected, owner, items, id, ref } = props;

  return (
    <RadioButtonWrapper id={id} ref={ref} className={`${owner ? 'owner' : ''}`}>
      {items.map((item, index) => (
        <RadioButtonLabel
          htmlFor={item.value}
          key={item.value + item.label}
          onClick={() => {
            handleChange(item.value);
          }}
        >
          <RadioButtonInput className={selected === item.value ? 'selected' : ''} tabIndex={index} />
          <RadioButtonLabelSpan>{item.label}</RadioButtonLabelSpan>
        </RadioButtonLabel>
      ))}
    </RadioButtonWrapper>
  );
};

export default RadioButton;

const RadioButtonWrapper = styled.div`
  position: relative;
  max-width: 200px;
`;

const RadioButtonLabel = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
`;

const RadioButtonInput = styled.div.attrs({ role: 'button' })`
  border-radius: 50%;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  display: block;
  border: 1px solid #979797;
  margin-right: 10px;
  background: #ffffff;
  position: relative;
  border-radius: 100%;
  appearance: none;
  background-color: white;
  outline: none;
  transition: all ease-in-out 0.2s;
  cursor: pointer;
  &:after {
    opacity: 0;
    top: 3px;
    left: 3px;
    right: 0;
    bottom: 0;
    width: 8px;
    height: 8px;
    background-color: #0751c2;
    transform: scale(0.5);
    transition: all ease-in-out 0.2s;
    border-radius: 100%;
    content: ' ';
    position: absolute;
    ${RadioButtonWrapper}.owner & {
      top: 50%;
      left: 50%;
      transform: scale(1) translate(-50%, -50%);
      background-color: blue;
      width: 5px;
      height: 5px;
    }
  }
  &.selected {
    ${RadioButtonWrapper}.owner & {
      background: #0e7873;
    }
    &:after {
      opacity: 0;
      top: 50%;
      left: 50%;
      transform: scale(1) translate(-50%, -50%);
      width: 8px;
      height: 8px;
      background-color: #0751c2;
      transition: all ease-in-out 0.2s;
      border-radius: 100%;
      opacity: 1;
      position: absolute;
      content: ' ';
      ${RadioButtonWrapper}.owner & {
        background-color: #f4c064;
      }
    }
  }

  ${RadioButtonWrapper}.owner & {
    background: #dbdfe5;
  }
`;

const RadioButtonLabelSpan = styled.span``;
